/**
 * GPI dual-mixer helpers.
 * Mixing period s41 / duration s42: [mixer1, mixer2].
 * Commands use mixer index 1–2 (cmd 58/59/40/223).
 */

import { isFeedListValue } from '@/functions/feedList';

/** True when s41 or s42 arrived as a JSON list (new dual-mixer firmware). */
export function isMultiMixerFirmwarePayload(slowData) {
    if (!slowData) {
        return false;
    }
    return isFeedListValue(slowData[41]) || isFeedListValue(slowData[42]);
}

/**
 * Parse mixer period/duration into [mixer1, mixer2].
 * Scalar legacy → [value, null].
 */
export function parseMixerList(raw) {
    if (raw == null || raw === '' || raw === 'xx') {
        return [null, null];
    }

    let arr = null;
    if (Array.isArray(raw)) {
        arr = [...raw];
    } else if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (trimmed.startsWith('[')) {
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                    arr = [...parsed];
                }
            } catch {
                // fall through to scalar
            }
        }
    }

    if (arr == null) {
        return [raw, null];
    }

    return [arr[0] ?? null, arr[1] ?? null];
}

/** Read mixer 1 or 2 from a list/scalar field. */
export function mixerListAt(raw, mixerIndex /* 1|2 */) {
    if (mixerIndex !== 1 && mixerIndex !== 2) {
        return null;
    }
    return parseMixerList(raw)[mixerIndex - 1] ?? null;
}
